let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1kReP")).then(() => parcelRequire('nmnZE'));